import { useMemo } from "react";

import type { JobSkill } from "@js/types/jobs";

type UseSelectedJobSkillsArg = {
  skills: number[] | undefined | "";
  topSkills: number[] | undefined | "";
  jobSkills: JobSkill[] | undefined;
};

export const useSelectedJobSkills = ({
  skills,
  topSkills,
  jobSkills,
}: UseSelectedJobSkillsArg) => {
  return useMemo(() => {
    if (!jobSkills?.length) {
      return { skills: [], topSkills: [] };
    }

    const skillsExistingInJob = (skills || []).filter((skillId) =>
      jobSkills.some(
        (jobSkill) => !jobSkill.is_top && jobSkill.skill.id === skillId,
      ),
    );
    const topSkillsExistingInJob = (topSkills || []).filter((skillId) =>
      jobSkills.some(
        (jobSkill) => jobSkill.is_top && jobSkill.skill.id === skillId,
      ),
    );

    return { skills: skillsExistingInJob, topSkills: topSkillsExistingInJob };
  }, [skills, topSkills, jobSkills]);
};
